<template>
  <div class="redemptions-page">
    <app-page-header title="Resgates">
      <button
        @click="onExportClicked()"
        :disabled="isExporting"
        class="export-btn"
        v-app-button.icon-left
      >
        <b-icon size="is-small" icon="download" />EXPORTAR
      </button>
    </app-page-header>

    <redemptions-table ref="redemptionsTable"></redemptions-table>
  </div>
</template>

<script>
import RedemptionsTable from '@/components/Tables/RedemptionsTable.vue';
import RedemptionService from '@/services/redemption.service';

export default {
  name: 'redemptions-page',
  components: {
    RedemptionsTable,
  },
  data: () => {
    return {
      isExporting: false,
    };
  },
  methods: {
    onExportClicked() {
      const {
        term,
        start_date,
        end_date,
        network_id,
        type,
      } = this.$refs.redemptionsTable.requestFilters;

      if (
        term ||
        start_date ||
        end_date ||
        network_id ||
        (type != undefined && type != null)
      ) {
        this.exportRedemptions();
        return;
      }

      this.$buefy.dialog.alert({
        title: 'Impossível exportar todos os resgates',
        message: 'Você precisa aplicar algum filtro para exportar os resgates!',
        confirmText: 'Entendi',
      });
    },
    exportRedemptions() {
      this.isExporting = true;

      const filters = this.$refs.redemptionsTable.requestFilters;

      RedemptionService.export(filters)
        .then(({ data }) => {
          const link = document.createElement('a');
          link.target = '_blank';
          link.href = data.url;
          link.click();
        })
        .catch(({ response }) => {
          this.toastify(
            response.data.message || 'Erro ao realizar exportação.',
            'error'
          );
        })
        .finally(() => (this.isExporting = false));
    },
  },
};
</script>
